import React from 'react';
import Map from 'common/components/Map/Map';
import { MAP_STYLE, MAP_MARKERS, MAP_BALLOON_STYLE } from '../configs/mapTheme';

/**
 * Carte des salons — listing (`.locator-map`) et fiche salon (`.infos-map`).
 *
 * La maquette posait une `<iframe>` `google.com/maps?q=Tchip+Coiffure,Paris` :
 * une *recherche* Google, qui affiche tous les salons de coiffure référencés
 * par Google et **aucun** salon du storelocator. On monte donc
 * `common/components/Map/Map` — exactement le montage de 2025_VOG — qui pose
 * une épingle par place et rien d'autre ; `configs/mapTheme.js` coupe en plus
 * tous les POI Google.
 *
 * Le conteneur reste celui de la maquette (sticky pleine hauteur sur le
 * listing, encadré arrondi sur la fiche) : le visuel ne bouge pas.
 *
 * `merchants` est optionnel : sans lui, `common` prend `state.merchants`
 * (le listing). La fiche salon passe `[merchant]`, n'ayant pas de liste.
 */
const LocatorMap = ({ title, className = 'locator-map', merchants, scrollwheel = false }) => (
  <div className={className} role="region" aria-label={title}>
    <Map
      mapSize={{ width: '100%', height: '100%' }}
      mapConfig={{ scrollwheel, styles: MAP_STYLE }}
      markers={MAP_MARKERS}
      balloon={{ style: MAP_BALLOON_STYLE }}
      merchants={merchants}
    />
  </div>
);

export default LocatorMap;
